var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 44,
    viewBox: "0 0 80 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.1297 18.3334C58.1297 18.3334 60.8199 16.3168 62.0718 15.1606C64.7575 12.6775 68.2967 9.42957 69.8011 6.04057C65.8522 5.76517 61.8259 5.91311 57.8679 5.89035C49.8222 5.84483 41.7742 5.82662 33.7284 5.82435C25.8465 5.82207 17.9123 5.58992 10.0373 5.97229C10.0259 5.97229 10.0145 5.97229 10.0031 5.97229C13.7495 11.28 18.1718 16.2099 23.616 19.7536C29.0603 23.2974 35.4332 25.7509 41.8948 25.0863C43.554 24.9156 47.0454 24.6721 47.0454 24.6721C47.0454 24.6721 50.0521 27.3032 51.7272 28.596C42.68 32.0942 32.1989 30.9289 23.5523 26.5293C18.3402 23.8778 13.7472 20.1132 9.88478 15.741C5.81524 11.1343 3.00663 5.9996 0.204842 0.575834C0.122905 0.411961 0.0796609 0.229879 0 0H80C79.7883 0.471137 79.629 0.878546 79.4287 1.26319C77.2187 5.56716 74.6764 9.7118 71.6743 13.5105C70.6774 14.7714 61.2501 22.997 61.2501 22.997L58.1297 18.3334Z",
    fill: "url(#paint0_linear_73_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7439 37.5999C21.6975 37.5089 23.2156 37.5339 23.6822 37.5339C23.6822 37.5339 26.8459 37.5567 28.4255 37.5681C31.5891 37.5908 34.7505 37.6113 37.9142 37.6341C45.0586 37.6841 52.4739 38.3123 59.5865 37.6045C59.261 36.4574 57.9432 33.296 57.249 31.9872C56.2612 30.1232 55.105 28.3433 53.7212 26.7456C48.8733 21.1534 41.0551 18.7954 34.0222 21.5039C33.8401 21.5744 33.4646 21.7542 33.4646 21.7542C33.4646 21.7542 29.4565 20.0836 27.5879 19.023C27.4195 18.9274 27.2237 18.8546 27.0007 18.6475C32.3744 14.7464 39.4619 13.465 45.9031 15.0741C58.0616 18.1103 64.53 30.4441 66.8425 41.8311C66.9176 42.202 67.0155 42.5685 67.1133 42.9349C67.2249 43.3492 67.1475 43.5859 66.6718 43.5631C66.3122 43.5472 65.9526 43.5586 65.5929 43.5586C49.0417 43.5586 32.4927 43.5722 15.9415 43.5586C15.3087 43.5586 14.6783 43.5563 14.0455 43.5495C13.9044 43.5495 13.7519 43.5404 13.6472 43.447C13.5061 43.3196 13.522 43.0943 13.5539 42.9053C14.4302 37.4383 19.0118 27.4147 19.0118 27.4147L19.2076 27.0096L24.4515 29.7795L24.2398 30.3007C24.2398 30.3007 22.3166 34.393 21.3561 36.4414C21.1923 36.7897 21.0261 37.0855 20.7462 37.5999H20.7439Z",
    fill: "url(#paint1_linear_73_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_73_2",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 30.6468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_73_2",
    x1: 40.3453,
    y1: 14.3963,
    x2: 40.3453,
    y2: 43.5646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.05a6c4f532ebcfa756055cee79363f17.svg";
export { ForwardRef as ReactComponent };